<template>
  <div class="c-siteMenuOverlay" :class="[{ 'is-open': isOpen }, menuClass]">
    <transition name="fade">
      <div
        class="c-siteMenuOverlay__background"
        @click="close"
        v-if="isOpen"
      ></div>
    </transition>
	<div class="c-siteMenuOverlay__inner" :class="placementClass">
		<div class="c-siteMenuOverlay__content">
			<div class="c-siteMenuOverlay__content__header">
				<div class="c-siteMenuOverlay__content__header__close" v-if="isOpen" @click="close">
					<iClose />
				</div>
			</div>
			<div class="c-siteMenuOverlay__content__body">
				<slot name="menu"></slot>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import iClose from '@/assets/icon/close.svg';


export default {
  name: "SiteMenuOverlay",
  components: {
	  iClose
  },

	data: () => ({
		menuClass: '',
    }),

  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
    placement: {
      type: String,
      default: "right",
    },
    showLoader: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      translations: (state) => state.app.translations,
    }),
    placementClass() {
      return "c-siteMenuOverlay__inner" + "--" + this.placement;
    },
  },
  methods: {
    close() {
		this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
@import "../../scss/abstracts/variables.scss";

.c-siteMenuOverlay {
  position: relative;
  z-index: 20;

  &__background {
    background-color: $c-overlay;
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 20;
  }

  &__inner {
	transition: $t-nice;
    display: flex;
    max-height: 100%;
    position: fixed;
    z-index: 20;
    top: 0;
    bottom: 0;
    opacity: 0;
	width: 100%;
    background-color: #243C48;;
    bottom: 0;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    transition: transform 500ms $t-nice, opacity 300ms $t-nice;

    &--left {
      left: 0;
      transform: translate(-100%, 0);
    }

    &--right {
      right: 0;
      transform: translate(100%, 0);
    }

    .is-open & {
      opacity: 1;
      transform: translate(0, 0);
    }
  }

  	&__content{
		padding-left: 30px;
		padding-right: 30px;
		width: 100%;
		padding-top: 57px;

		&__header{
			height: 35px;
			margin-bottom: 30px;
			display: flex;
			justify-content: flex-end;

			&__close{
				cursor: pointer;
				height: 50px;
				width: 80px;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				svg{
					.fill{
						fill: $c-white;
					}
					width: 16px;
				}
				&:hover{
					cursor: pointer;
					svg{
						.fill{
							fill: rgba($c-white, .5);
						}

					}
				}
			}
		}

		&__body{
			width: 100%;
			height: calc(100% - 130px);
			// height: 100%;
			overflow-y: scroll;
    		overflow-x: hidden;
			display: flex;
			align-items: center;
			// padding-bottom: 125px;
			// padding-top: 30%;

			&::-webkit-scrollbar {
			width: 5px;
			}
			-ms-overflow-style: none;
			scrollbar-width: none;

			&::-webkit-scrollbar-thumb{
				// background-color: $c-darkblue;

				&:hover{
					// background-color: darken($color: $c-darkblue, $amount: 10)
				}
			}
			&::-webkit-scrollbar-track{
				background: transparent;
			}

		}
  	}

  &.is-open {
    .c-siteMenuOverlay__inner {
      opacity: 1;
      transform: translate(0, 0);
    }
  }
}

@media all and (max-width: 768px) {
	.c-siteMenuOverlay {
		position: relative;

		&__content{
			padding-top: 30px;
		}
	}
}

</style>
